/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';
import { useIntl } from 'react-intl';

import Heading from '@atlaskit/heading/heading';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Stack, Text, xcss } from '@atlaskit/primitives';

import { messages } from './messages';

const styles = xcss({
	paddingBlock: 'space.1000',
	paddingInline: 'space.100',
	textAlign: 'center',
});

export function ErrorState(): JSX.Element {
	const { formatMessage } = useIntl();

	return (
		<Stack space="space.050" testId="global-invite--error-state" xcss={styles}>
			<Heading size="xsmall">{formatMessage(messages.errorStateHeading)}</Heading>
			<Text size="small" color="color.text.subtle">
				{formatMessage(messages.errorStateDescription)}
			</Text>
		</Stack>
	);
}
